module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_sticky_content.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_sticky_content.png
// module id = gK7B
// module chunks = 0